import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';
import { UiCardComponent, UiEmptyStateComponent } from '@nexus/frontend-shared-ui';
import type { WishlistDetailAccessStateView } from '../../types/wishlist-detail-access-state-view.interface';

@Component({
  selector: 'wishlist-detail-access-state',
  imports: [UiCardComponent, UiEmptyStateComponent],
  templateUrl: './wishlist-detail-access-state.component.html',
  styleUrl: './wishlist-detail-access-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistDetailAccessStateComponent {
  public readonly state: InputSignal<WishlistDetailAccessStateView> =
    input.required<WishlistDetailAccessStateView>();
}
